import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
 
export default function MapaLeafComuna({lista, setDtoRegistro, changeBandera, getListMapDet, setListMapDet,fSelect  }) {
  const mapRef = useRef()
  //const params = useParams()
  //let history = useHistory();
  
  //const [cargando, setCargando] = useState(true)
  //const [centro, setCentro] = useState([-17.3936218,-66.2336069])
  //const [listPoligono, setListPoligono] = useState([])
  //const hoy=moment(new Date()).format('YYYY-MM-DD')      

  useEffect(()=>{             
    
   mapRef.current =  leaflet.map('map').setView([19.3172475,-98.9922521], 12);
    leaflet.tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFkdXZhIiwiYSI6ImNsNmU5aGRmdDJwMjAzYm4zcW1rbHFmbW8ifQ.sN0kLoGEK5Xmt-uJ6QHK5w",//'https://tile.openstreetmap.org/{z}/{x}/{y}.png', 
      {foo: 'bar',
      maxZoom: 19,   id: 'mapbox/streets-v11',
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    //console.log(lista.length);
    
    if (lista.length!==0   ) {
      const nvoList =lista 
      const centro =[nvoList[0].DtLat, nvoList[0].DtLon]
      mapRef.current.setView(centro);
      let arrPoligono3=[]
      nvoList.forEach((poligono)=>{
        let arrPath=[]       
        if (poligono.gps) {
          poligono.gps.forEach((paths)=>{          
            arrPath.push([paths.Lt,paths.Ln])
          })
        }
        let nvoarr=[]
        nvoarr.push(arrPath)
        // console.log(arrPoligono3 ,poligono);
        if (arrPoligono3.length===0) {          
          
          arrPoligono3.push({color:poligono.DtCol, arregloPol:nvoarr})
        }
        else{          
          const filtro = arrPoligono3.filter((elemento)=>elemento.color===poligono.DtCol) 
          if (filtro.length===0) {
            arrPoligono3.push({color:poligono.DtCol, arregloPol:nvoarr})  
          }
          else{
            const filtro2 = arrPoligono3.filter((elemento)=>elemento.color!==poligono.DtCol) 
            if (filtro2.length===0) {
              arrPoligono3.push({color:poligono.DtCol, arregloPol:nvoarr})  
            }
            else{
            let aux1=[]
            let auxFiltro=filtro[0].arregloPol
            //console.log(filtro[0].arregloPol);
            
            auxFiltro.push(nvoarr)
           // console.log(auxFiltro);
            
            arrPoligono3.push(...filtro2,{color:poligono.DtCol, arregloPol:auxFiltro})  
            }
          }
          
        }         
           //arrPoligono2.push(arrPath)
        let auxAlt=38 , auxAnch=30
        if (poligono.DtNom <10) {
          auxAlt=38
          auxAnch=20
        }
        
        const greenIcon = nvoIconLeaflet(`https://daduva-cartografia.sfo3.cdn.digitaloceanspaces.com/Sec/Secc${poligono.DtNom}.svg`, poligono.DtId,auxAnch,auxAlt) 
        let marker = leaflet.marker([poligono.DtLat,poligono.DtLon], {icon:greenIcon});    
        const cadena=`${poligono.DtNom}`          
        marker.bindPopup(cadena).openPopup();
        marker.addTo(mapRef.current).on('click', mostrar);
      })
     
       arrPoligono3.forEach((poligono)=>{
        nvoPoligono(poligono.arregloPol, poligono.color)   
      })  
      
      //nvoPoligono(arrPoligono2, "#F08652")   
      /* const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.5, fillColor: ['#9a8fcd', ]});
      polygon.addTo(mapRef.current); 
      const polygon2 = leaflet.polygon(arrPoligono2, { fillOpacity: 0.5, fillColor: [ "#F08650" ]});
      polygon2.addTo(mapRef.current);  */
    }
    
    return () => {
      mapRef.current = null
       
    }

  },[ ]) 

  const nvoPoligono=(arrPoligono, color)=>{ //  
    //const polygon = leaflet.polygon(arrPoligono, {fillOpacity: 0.03,fillColor: color});
    const polygon = leaflet.polygon(arrPoligono, {fillColor: color});
    polygon.addTo(mapRef.current); 
  }

/*   useEffect(()=>{         
    
    if (listaPromovid && listaPromovid.lenght!== 0 ) {
      listaPromovid.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        { let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })
          }      
          const promoIcon = nvoIconLeaflet('/marker-icon-2x-green.png')
          let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:promoIcon});    
          const cadena=`${poligono.Nom}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);  
        }        
      })         
    }          
    
  },[listaPromovid, ])  */

  const nvoIconLeaflet=(iconUrl,auxID, iconAncho, auxAlt)=>{
    const altura=auxAlt ??41
    const nvo=new leaflet.Icon({
      id:auxID,
      iconUrl: iconUrl,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [iconAncho??25, altura],
      iconAnchor: [iconAncho??12, altura],
      popupAnchor: [1, -34],
      shadowSize: [iconAncho??41, altura]
    });
    return nvo
  }
 
  const mostrar=(e)=>{
    
    const filtro = lista.filter((marcador)=>marcador.DtId ===e.target.options.icon.options.id)
    //console.log(e.target.options.icon.options.id,filtro);       
    changeBandera()
    //changeBandera(false)
    setDtoRegistro([]) 
 
    getListMapDet(  e.target.options.icon.options.id)
    //setDtoRegistro(filtro[0]) 
    setListMapDet([])
     setTimeout(() => {
      changeBandera() 
      setDtoRegistro(filtro[0]) 
    }, 500); 
    /* setTimeout(() => {
      getListMapDet(e.target.options.icon.options.id)      
    }, 200);  */
    
  }
 
  return (  
    <div id="map" ref={mapRef} style={{height:"100%" }}/>  
  );
}